module.exports = __webpack_public_path__ + "static/media/WMOVR_SUSHI.081e0bc1.png";